module.exports = __webpack_public_path__ + "static/template-home-hero-background-210f8fe41f8314d6dd8f11d07815cdeb.jpg";